import React, { useState, useEffect } from 'react';
import {
  Box, Grid, Layer, Button, Heading,
} from 'grommet';

function InfoBox(props) {
  const {
    dataSource, active, setActive, target,
  } = props;

  const [churchData, setChurchData] = useState([]);

  useEffect(() => {
    fetch(`${dataSource}/church/${target}`, {
      method: 'GET',
      mode: 'cors',
    })
      .then(response => response.json())
      .then(responseJson => setChurchData(responseJson))
      .then(console.log('Requested Data'))
      .catch((error) => {
        alert(`Couldn't access data for ${target}`);
      });
  }, [dataSource, target, active]);

  return (
    <Layer
      modal
      onClickOutside={() => setActive(false)}
    >
      <Grid
        rows={['xsmall', 'medium', 'xxsmall']}
        columns={['medium', 'medium']}
        gap="small"
        areas={[
          { name: 'header', start: [0, 0], end: [1, 0] },
          { name: 'col1', start: [0, 1], end: [0, 1] },
          { name: 'col2', start: [1, 1], end: [1, 1] },
          { name: 'footer', start: [0, 2], end: [1, 2] },
        ]}
        justifyContent="center"
      >
        <Box gridArea="header" background="red">
          <Heading
            margin="none"
            alignSelf="center"
            textAlign="center"
            truncate
            gridArea="header"
            size="small"
            maxWidth="medium"
          >
            {churchData.name}

          </Heading>
        </Box>
        <Box gridArea="col1" background="purple">{churchData.billingstreet}</Box>
        <Box gridArea="col2" background="purple">{churchData.name}</Box>
        <Box gridArea="footer" background="blue">
          <Button
            onClick={() => setActive(false)}
            label="Dismiss"
          />
        </Box>
      </Grid>
    </Layer>
  );
}

export default InfoBox;
